export const engagementLevels = [
  {
    title: "Prompting",
    subtitle: "Quick Answers, Drafts, and Ideas",
    description:
      "The simplest way to use an LLM is to just ask it something. You give it a prompt, and it gives you a response. This is perfect for tasks like writing an email, summarizing an article, or brainstorming names for your new project. Think of this as your AI Assistant."
  },
  {
    title: "Reasoning Mode",
    subtitle: "Think With Me",
    description:
      "Beyond basic prompting, modern models can reason through problems step-by-step. You can ask them to compare options, solve logic puzzles, or walk through a scenario in detail. Some models (like Claude or GPT-4 Turbo) allow for more 'thinking time' — like having a smart tutor or analyst on hand."
  },
  {
    title: "Tool Use",
    subtitle: "Coding, Spreadsheets, and Software Help",
    description:
      "Some LLMs can operate inside your tools — like writing code in your IDE (with tools like Cursor), editing docs, generating spreadsheets, or even using your terminal. These setups turn your model into a technical co-pilot, helping you build faster, fix bugs, and automate tricky workflows."
  },
  {
    title: "Deep Research",
    subtitle: "Ask the Web, Synthesise the World",
    description:
      "If you're trying to understand a topic or explore something new, LLMs with web access (like Perplexity or Grok) can act as hyper-fast researchers. They search across sources, summarize what they find, and even provide citations. Great for decision-making, comparisons, and staying up to date."
  },
  {
    title: "Agents & Automation",
    subtitle: "Do It For Me",
    description:
      "At the most advanced level, LLMs can run tasks on your behalf — not just responding, but taking initiative. Agents can book meetings, update documents, scrape websites, or even manage recurring workflows. These setups feel like having a junior team member who works around the clock."
  }
]; 